import { useGetApiQuoteApiGetQuoteId } from "../openapi/backendApi";
import { useEasySession } from "../providers/easySessionProvider";
import { useAtomValue } from "jotai";

import { externalCredentialsHandoffAtom } from "./externalCredentialsHandoff";

export interface EnsureQuoteExistsResult {
  isReady: boolean;
  isError: boolean;
  refetch: () => void;
}

export function useEnsureQuoteExists(): EnsureQuoteExistsResult {
  const { isEasySessionInit } = useEasySession();
  const isExternalCredentialsHandoffInProgress = useAtomValue(
    externalCredentialsHandoffAtom,
  );
  // Wait for the first CheckLoginState (it sets the session cookie - parallel
  // cookie-less requests would each get their own session) and for any
  // external-credentials handoff (getQuoteId would otherwise create an
  // anonymous quote while the handoff attaches the real one).
  const isWaiting = isEasySessionInit || isExternalCredentialsHandoffInProgress;

  const {
    data: quoteId,
    isSuccess,
    isError,
    refetch,
  } = useGetApiQuoteApiGetQuoteId({
    query: { enabled: !isWaiting },
  });

  return {
    isReady: !isWaiting && isSuccess && !!quoteId?.data,
    isError: !isWaiting && isError,
    refetch: () => {
      refetch();
    },
  };
}
